<template>
	<div class="body">
		<div class="body-container">
			<div class="left-tabs">
				<div class="tab" v-for="(tab, index) in leftTabList" :key="index"
					:class="{'active-tab': activeLeftTab == index}" @click="changeLeftTab(index)">
					<div>{{ tab.name }}</div>
					<img class="active-arrow" src="../assets/icons/arrow_right2.png" />
				</div>
			</div>

			<div class="right-content">
				<div class="content-title" v-if="leftTabList && leftTabList.length > 0">
					<img class="title-wing" src="../assets/icons/title_wing_left.png" />
					<span class="title-text">{{ leftTabList[activeLeftTab].name }}</span>
					<img class="title-wing" src="../assets/icons/title_wing_right.png" />
				</div>

				<!-- 专业院校分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'major_academy'">
					<div>
						<el-form :inline="true">
							<el-form-item label="年份" required>
								<el-select class="select-width" v-model="year" placeholder="请选择">
									<el-option v-for="item in industryYearList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="学历层次" required>
								<el-select class="select-width" v-model="degree" placeholder="请选择"
									@change="onLevelChange">
									<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="专业大类">
								<el-select v-model="topMajor" placeholder="请输入关键字" class="select-width" filterable
									remote :clearable=true reserve-keyword :remote-method="loadTopMajorList"
									@change="changeTopMjor">
									<el-option v-for="item in topMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业类">
								<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-width"
									:clearable=true filterable remote reserve-keyword
									:remote-method="loadParentMajorList" @change="changeParentMajor">
									<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业">
								<el-select v-model="major" placeholder="请输入关键字" class="select-width" :clearable=true
									filterable remote reserve-keyword :remote-method="loadMajorList">
									<el-option v-for="item in majorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="省直辖市">
								<el-select class="select-width" v-model="province" placeholder="请选择" filterable
									:clearable=true @change="changeProvince">
									<el-option v-for="item in provinceList" :key="item.province_code"
										:label="item.province_name" :value="item.province_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地级市">
								<el-select class="select-width" v-model="city" placeholder="请选择" filterable
									:clearable=true>
									<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
										:value="item.city_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="medium"
									@click="queryMajorAcademy">分 析</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" class="el-button--success" icon="el-icon-download"
									size="medium" @click="exportMajorAcademy">导 出</el-button>
							</el-form-item>

						</el-form>

						<div class="dataTips" v-if="dataTips">{{ dataTips }}</div>

						<el-table border :data="dataList">
							<el-table-column label="省直辖市" align="center" prop="province" />
							<el-table-column label="地级市" align="center" prop="city" />
							<el-table-column label="学校名称" align="center" prop="college_name" />
							<el-table-column label="招生数量(人)" align="center" prop="enroll_num" />
						</el-table>

						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="queryMajorAcademy" />
						</div>
					</div>
				</div>

				<!-- 专业人才供给分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'major_enroll'">
					<div>
						<el-form :inline="true">
							<el-form-item label="招生年份" required>
								<el-select class="select-width" v-model="year" placeholder="请选择">
									<el-option v-for="item in yearList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="学历层次" required>
								<el-select class="select-width" v-model="degree" placeholder="请选择"
									@change="onLevelChange">
									<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="省直辖市">
								<el-select class="select-width" v-model="province" filterable placeholder="请选择"
									:clearable=true @change="changeProvince">
									<el-option v-for="item in provinceList" :key="item.province_code"
										:label="item.province_name" :value="item.province_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地级市">
								<el-select class="select-width" v-model="city" filterable placeholder="请选择"
									:clearable=true>
									<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
										:value="item.city_code">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="院校名称">
								<el-select v-model="college" placeholder="请输入关键字" class="select-width" filterable remote
									reserve-keyword :remote-method="loadInnerCollegeList" :clearable=true>
									<el-option v-for="item in collegeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="专业大类">
								<el-select v-model="topMajor" placeholder="请输入关键字" class="select-width" filterable
									remote :clearable=true reserve-keyword :remote-method="loadTopMajorList"
									@change="changeTopMjor">
									<el-option v-for="item in topMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业类">
								<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-width"
									:clearable=true filterable remote reserve-keyword
									:remote-method="loadParentMajorList" @change="changeParentMajor">
									<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业">
								<el-select v-model="major" placeholder="请输入关键字" class="select-width" :clearable=true
									filterable remote reserve-keyword :remote-method="loadMajorList">
									<el-option v-for="item in majorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="medium"
									@click="loadMajorEnroll('query')">查 询</el-button>

								<el-button type="primary" class="el-button--success" icon="el-icon-download"
									size="medium" @click="toExportMajorEnroll()">导出</el-button>
							</el-form-item>
						</el-form>

						<div class="dataTips" v-if="dataTips">{{ dataTips }}</div>

						<el-table border :data="dataList" stripe>
							<el-table-column label="专业" align="center" prop="major_name" />
							<el-table-column label="招生年份" align="center" prop="year" />
							<el-table-column label="普通招生数(人)" align="center" prop="normal_num" />
							<el-table-column label="其它招生数(人)" align="center" prop="other_num" />
							<el-table-column label="总招生数(人)" align="center" prop="num" />
						</el-table>

						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="loadMajorEnroll('more')" />
						</div>
					</div>
				</div>

				<!-- 专业行业分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'major_industry'">
					<div>
						<el-form :inline="true">
							<el-form-item label="年份" required>
								<el-select class="select-width" v-model="industryYear" placeholder="请选择">
									<el-option v-for="item in industryYearList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="学历层次" required>
								<el-select class="select-width" v-model="degree" placeholder="请选择"
									@change="onLevelChange">
									<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="省直辖市">
								<el-select class="select-width" v-model="province" filterable placeholder="请选择"
									@change="changeProvince" :clearable=true>
									<el-option v-for="item in provinceList" :key="item.province_code"
										:label="item.province_name" :value="item.province_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地级市">
								<el-select class="select-width" v-model="city" placeholder="请选择" :clearable=true>
									<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
										:value="item.city_code">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="专业大类">
								<el-select v-model="topMajor" placeholder="请输入关键字" class="select-width" filterable
									remote :clearable=true reserve-keyword :remote-method="loadTopMajorList"
									@change="changeTopMjor">
									<el-option v-for="item in topMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业类">
								<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-width"
									:clearable=true filterable remote reserve-keyword
									:remote-method="loadParentMajorList" @change="changeParentMajor">
									<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="专业">
								<el-select v-model="major" placeholder="请输入关键字" class="select-width" :clearable=true
									filterable remote reserve-keyword :remote-method="loadMajorList">
									<el-option v-for="item in majorList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="medium"
									@click="loadMajorIndustry('query')">查 询</el-button>

								<el-button type="primary" class="el-button--success" icon="el-icon-download"
									size="medium" @click="exportMajorIndustry">导 出</el-button>
							</el-form-item>
						</el-form>

						<el-table border :data="dataList" stripe>
							<el-table-column label="专业" align="center" prop="major_name" />
							<el-table-column label="院校数量" align="center" prop="college_num">
								<template v-slot="{ row }">
									<label style="color: blue;" @click="clickRoute(row)">{{row.college_num}}</label>
								</template>
							</el-table-column>
							<el-table-column label="行业" align="center" prop="industry_name" />
						</el-table>

						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="loadMajorIndustry('more')" />
						</div>
					</div>
				</div>

				<!-- 院校专业分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'academy_major'">
					<div>
						<el-form :inline="true">
							<div class="two-side-ctr">
								<label class="btn-row-ctr">
									<el-form-item label="年份" required>
										<el-select class="select-width" v-model="industryYear" placeholder="请选择">
											<el-option v-for="item in industryYearList" :key="item" :label="item"
												:value="item">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="院校名称" required>
										<el-select v-model="college" placeholder="请输入关键字" class="select-width"
											filterable remote reserve-keyword :remote-method="loadCollegeList">
											<el-option v-for="item in collegeList" :key="item.id" :label="item.name"
												:value="item.id">
											</el-option>
										</el-select>
									</el-form-item>

									<el-form-item>
										<el-button type="primary" icon="el-icon-search" size="medium"
											@click="queryAcademyMajor">分 析</el-button>
									</el-form-item>
								</label>

								<label v-if="dataList && dataList.length > 0" class="btn-row-ctr">
									<el-form-item>
										<el-button type="primary" icon="el-icon-download" class="el-button--success"
											size="medium" @click="exportAcademyMajor">导 出</el-button>
									</el-form-item>
				<!-- 					<el-form-item>
										<el-button type="primary" icon="el-icon-message" class="el-button--success"
											size="medium" @click="clickAcademyRank">职教数排行</el-button>
									</el-form-item>
									<el-form-item>
										<el-button type="primary" icon="el-icon-upload" class="el-button--danger"
											size="medium" @click="exportAcademyReport">年报关键数据</el-button>
									</el-form-item> -->
								</label>
							</div>

						</el-form>
						<div class="dataTips" v-if="dataTips">{{ dataTips }}</div>
						<el-table :data="dataList" :span-method="objectSpanMethod2" border>

							<el-table-column :label="columnList[0]" align="center" prop="top_name" />
							<el-table-column :label="columnList[1]" align="center" prop="top_num" />
							<el-table-column :label="columnList[2]" align="center" prop="parent_name" />
							<el-table-column :label="columnList[3]" align="center" prop="parent_num" />
							<el-table-column :label="columnList[4]" align="center" prop="name">
								<template v-slot="{ row }">
									<label style="color: blue;" @click="handleCellClick(row)">{{row.name}}</label>
								</template>
							</el-table-column>
							<el-table-column :label="columnList[5]" align="center" prop="major_num" />
						</el-table>

						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="queryAcademyMajor" />
						</div>
					</div>
				</div>
				<!-- 产业占比分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'industry_rate'">
					<div>
						<el-form :inline="true">
							<el-form-item label="年份" required>
								<el-select class="select-width" v-model="industryYear" placeholder="请选择">
									<el-option v-for="item in industryYearList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="学历层次" required>
								<el-select class="select-width" v-model="degree" placeholder="请选择"
									@change="onLevelChange">
									<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
										:value="item.name" />
								</el-select>
							</el-form-item>
							<el-form-item label="省直辖市">
								<el-select class="select-width" v-model="province" filterable placeholder="请选择"
									@change="changeProvince" :clearable=true>
									<el-option v-for="item in provinceList" :key="item.province_code"
										:label="item.province_name" :value="item.province_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地级市">
								<el-select class="select-width" v-model="city" filterable placeholder="请选择"
									:clearable=true>
									<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
										:value="item.city_code">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="院校名称">
								<el-select v-model="college" placeholder="请输入关键字" class="select-width" filterable remote
									reserve-keyword :remote-method="loadCollegeList" :clearable="true">
									<el-option v-for="item in collegeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="medium"
									@click="queryIndustryRate">分 析</el-button>
							</el-form-item>
						</el-form>

						<el-table :data="dataList" border>
							<el-table-column label="专业对应的产业" align="center" prop="name" />
							<el-table-column label="专业布点占比" align="center" prop="rate" />
							<el-table-column label="专业招生数占比" align="center" prop="enrollRate" />
						</el-table>
					</div>
				</div>

				<!-- 行业 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'hot_major'">
					<div>
						<el-form :inline="true">
							<el-form-item label="年份" required>
								<el-select class="select-width" v-model="industryYear" placeholder="请选择">
									<el-option v-for="item in industryYearList" :key="item" :label="item" :value="item">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="学历层次" required>
								<el-select class="select-width" v-model="degree" placeholder="请选择">
									<el-option v-for="item in degreeList" :key="item.name" :label="item.name"
										:value="item.name">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="省直辖市">
								<el-select class="select-width" v-model="province" filterable placeholder="请选择"
									@change="changeProvince" :clearable=true>
									<el-option v-for="item in provinceList" :key="item.province_code"
										:label="item.province_name" :value="item.province_code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="地级市">
								<el-select class="select-width" v-model="city" filterable placeholder="请选择"
									:clearable=true>
									<el-option v-for="item in cityList" :key="item.city_code" :label="item.city_name"
										:value="item.city_code">
									</el-option>
								</el-select>
							</el-form-item>

							<el-form-item label="行业门类" required>
								<el-select class="select-width" v-model="sector" placeholder="请选择"
									@change="changeSector">
									<el-option v-for="item in sectorTree" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="行业大类">
								<el-select class="select-width" v-model="childSector" placeholder="请选择" :clearable=true>
									<el-option v-for="item in childIndustryList" :key="item.code" :label="item.name"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" icon="el-icon-search" size="medium"
									@click="queryMajorCollegeBySector">分 析</el-button>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" class="el-button--success" icon="el-icon-download"
									size="medium" @click="exportMajorCollegeBySector">导 出</el-button>
							</el-form-item>
						</el-form>

						<div class="dataTips" v-if="dataTips">{{ dataTips }}</div>
						<el-table :data="dataList" border>
							<el-table-column label="专业" align="center" prop="major_name" />
							<el-table-column label="院校数量" align="center" prop="college_num">
								<template v-slot="{ row }">
									<label style="color: blue;" @click="clickRoute(row)">{{row.college_num}}</label>
								</template>
							</el-table-column>
							<el-table-column label="招生人数(人)" align="center" prop="college_num">
								<template v-slot="{ row }">
									<label>{{row.enroll_num}}</label>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>

				<!-- 专业群分析 -->
				<div class="conditions-data"
					v-if="leftTabList && leftTabList.length > 0 && leftTabList[activeLeftTab].type == 'major_major'">
					<div>
						<div class="major-group-action-ctr">
							<el-button type="primary" icon="el-icon-search" size="medium"
								@click="createUserGroup()">新建专业群</el-button>
						</div>


						<el-table :data="dataList" border>

							<el-table-column label="专业群名称" align="center" prop="name" min-width="1">
								<template v-slot="{ row }">
									<label v-if="row.showEditMajor == 1" style="color: blue;"
										@click="clickEditGroupMajor(row.id)">{{row.name}}</label>
									<label v-else>{{row.name}}</label>
								</template>
							</el-table-column>
							<el-table-column label="专业数" align="center" prop="major_num" min-width="1">
								<template v-slot="{ row }">
									<label v-if="row.showEditMajor == 1" style="color: blue;"
										@click="clickEditGroupMajor(row.id)">{{row.major_num}}</label>
									<label v-else>{{row.major_num}}</label>
								</template>
							</el-table-column>
							<el-table-column label="共性行业数" align="center" prop="industry_num" min-width="1">
								<template v-slot="{ row }">
									<label style="color: blue;"
										@click="clickIndustry(row.industryPath)">{{row.industry_num}}</label>
								</template>
							</el-table-column>
							<el-table-column label="创建时间" align="center" prop="created_at" min-width="1" />
							<el-table-column label="操作" min-width="4">
								<template v-slot="{ row }">
									<label class="btn-row-ctr">
										<el-button type="primary" icon="el-icon-search" size="small"
											v-if="row.showEditMajor == 1"
											@click="clickEditGroupMajor(row.id)">编辑专业</el-button>
										<el-button type="primary" class="el-button--info" icon="el-icon-edit"
											size="small" @click="clickIndustry(row.industryPath)">共性行业</el-button>
										<el-button type="primary" icon="el-icon-message" class="el-button--success"
											size="small" @click="clickExportGroupReport(row.id)">导出报告</el-button>
										<el-button type="primary" icon="el-icon-message" class="el-button--danger"
											size="small" @click="clickDelUserGroup(row.id)">删除</el-button>
									</label>

								</template>
							</el-table-column>
						</el-table>

						<div class="pagination">
							<pagination v-show="total>0" :total="total" :page.sync="queryParams.page"
								:limit.sync="queryParams.pageSize" @pagination="getUserMajorGroup" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<el-dialog :title="clgRankData.title" :visible.sync="showClgRankDialog" append-to-body v-if="showClgRankDialog"
			align="center">
			<div class="data-table">
				<el-table :data="clgRankData.list" border>
					<el-table-column prop="year" label="年份" align="center"></el-table-column>
					<el-table-column prop="quality_rank" label="培养质量排名" align="center"></el-table-column>
					<el-table-column prop="res_rank" label="教学资源排名" align="center"></el-table-column>
					<el-table-column prop="service_rank" label="服务贡献排名" align="center"></el-table-column>
					<el-table-column prop="effect_rank" label="国际影响排名" align="center"></el-table-column>
					<el-table-column prop="policy_rank" label="政策落实排名" align="center"></el-table-column>
					<el-table-column prop="score_rank" label="整体排名" align="center"></el-table-column>
				</el-table>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" class="el-button--info" @click="closeClgRankDialog()">关 闭</el-button>
				<el-button type="primary" icon="el-icon-message" @click="clickToReport()">下载年报详细数据</el-button>
			</div>
		</el-dialog>

		<el-dialog :visible.sync="showGroupDialog" title="新建专业群" align='center'>
			<div class="create-group-ctr">
				<div class="group-row">
					<label>专业群名字</label>
					<el-input v-model="groupName" placeholder="请输入名字" class="group-input" />
				</div>

				<div class="group-row">
					<label>省直辖市</label>
					<el-select class="group-select" v-model="province" filterable placeholder="请选择" :clearable=true>
						<el-option v-for="item in provinceList" :key="item.province_code" :label="item.province_name"
							:value="item.province_code">
						</el-option>
					</el-select>
				</div>
			</div>


			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="confirmCreateGroup()">确 定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="编辑专业" :visible.sync="showGroupMajorDialog" append-to-body v-if="showGroupMajorDialog"
			align="center" @close="onGroupDialogClosed">

			<div class="tab-ctr">
				<label v-for="(item,index) in groupAddList"
					:class="['tab-item', index == groupAddIndex ? 'tab-item-s' : '']" :key="index"
					@click="clickAddTab(index)">{{item.name}}</label>
			</div>

			<el-form :inline="true" align="left">
				<el-form-item label="专业大类">
					<el-select v-model="topMajor" placeholder="请输入关键字" class="select-group-width" filterable remote
						:clearable=true reserve-keyword :remote-method="loadGroupTopMajorList"
						@change="changeGroupTopMjor">
						<el-option v-for="item in topMajorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业类">
					<el-select v-model="parentMajor" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupParentMajorList"
						@change="changeGroupParentMajor">
						<el-option v-for="item in parentMajorList" :key="item.code" :label="item.name"
							:value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="专业">
					<el-select v-model="major" placeholder="请输入关键字" class="select-group-width" :clearable=true
						filterable remote reserve-keyword :remote-method="loadGroupMajorList"
						@change="changeGroupMajor">
						<el-option v-for="item in majorList" :key="item.code" :label="item.name" :value="item.code">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div class="data-table">
				<el-table :data="groupDataList" border>
					<el-table-column prop="name" label="专业" align="center"></el-table-column>
					<el-table-column prop="topMajor" label="专业大类" align="center"></el-table-column>
					<el-table-column prop="parentMajor" label="专业类" align="center"></el-table-column>
					<el-table-column label="操作" align="center">
						<template v-slot="{ row }">
							<el-button type="primary" size="small" @click="clickAddGroupMajor(row.code)"
								v-if="row.isAdd != 1">添加</el-button>
							<el-button type="warning" size="small" @click="clickRemoveGroupMajor(row.code)"
								v-else>移除</el-button>
						</template>
					</el-table-column>

				</el-table>

				<div class="pagination">
					<pagination v-show="total>0" :total="total" :page.sync="groupQueryParams.page"
						:limit.sync="groupQueryParams.pageSize" @pagination="queryGroupMajorData" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer" align="center">
				<el-button type="primary" @click="clickCloseGroupDialog()">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getLeftTypeList,
		getTopMajorList,
		getParentMajorList,
		getMajorList,
		getAddrTree,
		analyzeMajorAcademy,
		queryCollege,
		queryInnerCollege,
		analyzeClgMajor,
		analyzeIndustryRate,
		getSectorPage,
		analyzeMajorCollegeBySector,
		getMajorDataByMajor,
		exportMajorAcademy,
		exportClgMajor,
		exportMajorCollegeBySector,
		queryAcademyRank,
		exportAcademyReport,
		getUserMajorGroup,
		createMajorGroup,
		getGroupTopMajorList,
		getGroupParentMajorList,
		getGroupMajorList,
		getGroupMajor,
		addGroupMajor,
		removeGroupMajor,
		deleteUserGroup,
		queryMajorEnroll,
		queryMajorEnrollYear,
		getDegreeData,
		getMajorIndustry,
		getConfigData,
		exportMajorEnroll,
		exportMajorIndustry
	} from "@/api/matrix"

	import {
		getSpanMap,
		isEmpty,
		createSpanMethod
	} from "@/utils/util"

	import {
		parse,
		handleProtocal,
		handleRouteProtocal
	} from "@/utils/protocal"

	import {
		Notification,
		Message,
		Loading
	} from 'element-ui'

	export default {
		name: "Matrix",
		data() {
			return {
				leftTabList: [],
				activeLeftTab: 0,
				topMajorList: [],
				topMajor: undefined,
				parentMajorList: [],
				parentMajor: undefined,
				majorList: [],
				major: undefined,
				provinceList: [],
				province: undefined,
				cityList: [],
				city: undefined,

				collegeList: [],
				college: undefined,

				dataList: [],
				total: 0,
				dataTips: undefined,
				columnList: ['专业大类', '大类招生数', '专业类', '类招生数', '专业', '专业招生数'],

				sector: undefined,
				childSector: '',
				degreeList: [],
				degree: undefined,

				queryParams: {
					page: 1,
					pageSize: 20
				},

				groupQueryParams: {
					page: 1,
					pageSize: 10
				},
				spanArr: [], // 存储合并信息
				pos: 0, // spanArr的索引位置,
				clgRankData: null,
				showClgRankDialog: false,
				showGroupDialog: false,
				groupName: '',
				groupAddList: [{
						'name': '未添加',
						'value': 2
					},
					{
						'name': '已添加',
						'value': 1
					},
				],
				groupAddState: 2,
				groupAddIndex: 0,
				showGroupMajorDialog: false,
				groupDataList: [],
				yearList: [],
				year: '',
				sectorTree: [],
				childIndustryList: [],
				industryYear: '',
				industryYearList: [],
				// 需要合并的字段（按顺序）
				mergeFields: ['top_name', 'parent_name'],
				// 所有字段
				allFields: ['top_name', 'top_num', 'parent_name', 'parent_num', 'name', 'major_num']
			}
		},
		created() {
			console.log('params', this.$route.query)
			this.initPageData();
		},
		watch: {
			// major(newVal, oldVal){
			// 	console.log('值变化了', newVal, oldVal);
			// 	if(newVal != oldVal && newVal != ''){
			// 		this.onMajorChange(newVal)
			// 	}
			// }
		},

		computed: {
			// 表格合并方法
			objectSpanMethod2() {
				return createSpanMethod(
					this.dataList,
					// 合并依据字段（按层级顺序）
					['top_name', 'parent_name'],
					// 所有需要参与合并的字段（按表格列顺序）
					['top_name', 'top_num', 'parent_name', 'parent_num', 'name', 'major_num'],
					// 字段映射：数值字段 → 对应的依据字段
					{
						'top_num': 'top_name', // top_num 跟随 top_name 合并
						'parent_num': 'parent_name' // parent_num 跟随 parent_name 合并
					}
				);
			},
		},

		methods: {
			initPageData() {
				this.loadConfig().then(() => {
					return getLeftTypeList();
				}).then(res => {
					this.leftTabList = res.data.list;
					this.initPassParams();
				});
			},

			initPassParams() {
				let params = this.$route.query
				if (params && !isEmpty(params.activeLeftTab)) {
					this.changeLeftTab(params.activeLeftTab, false)
		
					if(params.province_code){
						this.province = parseInt(params.province_code);
					}
					
					if(params.city_code){
						this.city = parseInt(params.city_code);
					}
					
					if (params.activeLeftTab == 1) {
						this.degree = params.degree;
						this.year = params.year;
						getMajorList({
							top_code: this.topMajor,
							parent_code: this.parentMajor,
							code: params.code
						}).then(res => {
							this.majorList = res.data.majorList;
							this.major = params.code
							this.queryMajorAcademy()
						});
					}else if (params.activeLeftTab == 4) {
                        this.sector = params.sector
                    }
				}
			},

			changeLeftTab(index, click=true) {
				this.activeLeftTab = index;
				this.columnList = ['专业大类', '大类招生数', '专业类', '类招生数', '专业', '专业招生数'];
				this.dataList = [];
				this.total = 0;
				this.queryParams = {
					page: 1,
					pageSize: 20
				}
				if (click){
					this.topMajor = ''
					this.parentMajor = ''
					this.major = ''
					this.province = ''
					this.city = ''
					this.college = ''
					this.degree = ''
					this.dataTips = ''
					this.sector = ''
				}

				if (this.leftTabList[this.activeLeftTab].type == 'major_major') {
					this.getUserMajorGroup();
				} else if (this.leftTabList[this.activeLeftTab].type == 'major_enroll') {
					this.loadEnrollYear();
				} else if (this.leftTabList[this.activeLeftTab].type == 'hot_major') {
					// this.loadSectorData();
				} else if (this.leftTabList[this.activeLeftTab].type == 'major_industry') {
					// this.loadMajorIndustryPage();
				} else if (this.leftTabList[this.activeLeftTab].type == 'major_academy') {

					// if(this.degreeList && this.degreeList.length > 0){
					// 	let length = this.degreeList.length;
					// 	let targetDegree = '高职高专';
					// 	for(let i = 0; i < length; i++){
					// 		if (this.degreeList[i]['name'] == targetDegree){
					// 			this.degree = this.degreeList[i]['name'];
					// 			break;
					// 		}
					// 	}
					// }

					if (this.industryYearList && this.industryYearList.length > 0) {
						this.year = this.industryYearList[0];
					}

				}
			},

			loadEnrollYear() {
				queryMajorEnrollYear().then(res => {
					this.yearList = res.data.yearList;
					this.degreeList = res.data.degreeList
				});
			},

			loadTopMajorList(query) {
				getTopMajorList({
					name: query,
					degree: this.degree
				}).then(res => {
					this.topMajorList = res.data.topMajorList;
				});
			},

			loadGroupTopMajorList(query) {
				getGroupTopMajorList({
					name: query
				}).then(res => {
					this.topMajorList = res.data.topMajorList;
				});
			},


			// onMajorChange(newValue){
			// 	getMajorDataByMajor({
			// 		'code': newValue
			// 	}).then(res => {
			// 		this.parentMajorList = res.data.parentList;
			// 		this.topMajorList = res.data.topList;
			// 		console.log('onMajorChange res', res)
			// 		console.log('this.topMajorList', this.topMajorList)
			// 		console.log('this.parentMajorList', this.parentMajorList)
			// 	});
			// },

			changeTopMjor(value) {
				console.log('changeTopMjor value', value)
				this.loadParentMajorList('');
				this.majorList = []
				this.major = ''
			},

			onLevelChange(value) {
				console.log('onLevelChange value', value)
				this.loadTopMajorList('');
				this.topMajor = ''
				this.parentMajor = ''
				this.parentMajorList = [];
				this.majorList = [];
				this.major = ''
			},


			clickMajorItem(item) {
				console.log('clickMajorItem item', item)
			},

			handleCellClick(item) {
				console.log('点击的单元格数据:', item);

				let url = item['majorUrl']

				handleProtocal(url)
			},

			loadParentMajorList(query) {
				getParentMajorList({
					name: query,
					top_code: this.topMajor,
					degree: this.degree
				}).then(res => {
					this.parentMajorList = res.data.parentMajorList;
					this.parentMajor = ''
					console.log('clear major--------')
				});
			},

			loadGroupParentMajorList(query) {
				getGroupParentMajorList({
					name: query,
					top_code: this.topMajor
				}).then(res => {
					this.parentMajorList = res.data.parentMajorList;
					this.parentMajor = ''
					console.log('clear major--------')
				});
			},

			changeParentMajor(value) {
				this.loadMajorList('');
			},


			loadMajorList(query) {
				console.log('loadMajorList query', query)
				getMajorList({
					name: query,
					top_code: this.topMajor,
					parent_code: this.parentMajor,
					degree: this.degree
				}).then(res => {
					this.majorList = res.data.majorList;
					this.major = ''
				});
			},

			loadGroupMajorList(query) {
				console.log('loadMajorList query', query)
				getGroupMajorList({
					name: query,
					top_code: this.topMajor,
					parent_code: this.parentMajor
				}).then(res => {
					this.majorList = res.data.majorList;
					this.major = ''
				});
			},

			loadConfig() {
				return getConfigData().then(res => {
					let realData = res.data;

					this.provinceList = realData.tree;
					this.industryYearList = realData.industryYearList;
					this.industryYear = this.industryYearList[0]
					this.degreeList = realData.degreeList;
					this.sectorTree = realData.industryTree;
				});
			},

			changeProvince(value) {
				console.log('province: ', value);
				this.provinceList.forEach(element => {
					if (element.province_code == value) {
						this.cityList = element.list;
					}
				});
			},

			changeSector(value) {
				console.log('province: ', value);
				this.sectorTree.forEach(element => {
					if (element.code == value) {
						this.childSector = '';
						this.childIndustryList = element.list;
					}
				});
			},


			queryMajorAcademy() {
				console.log('queryMajorAcademy this.province', this.province)
				this.queryParams.top_code = this.topMajor;
				this.queryParams.parent_code = this.parentMajor;
				this.queryParams.code = this.major;
				this.queryParams.province_code = this.province;
				this.queryParams.city_code = this.city;
				this.queryParams.year = this.year;
				this.queryParams.degree = this.degree;
				analyzeMajorAcademy(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
					this.dataTips = res.data.totalData;
				});
			},

			toExportMajorEnroll() {
				let params = this.queryParams;
				params['download'] = 2;
				exportMajorEnroll(this.queryParams).then(res => {
					let url = res.data.url;
					handleProtocal(url);
				})
			},

			loadMajorEnroll(type) {
				if (type == 'query') {
					this.queryParams.page = 1;
				}

				this.queryParams.top_code = this.topMajor;
				this.queryParams.parent_code = this.parentMajor;
				this.queryParams.code = this.major;
				this.queryParams.province_code = this.province;
				this.queryParams.city_code = this.city;
				this.queryParams.year = this.year;
				this.queryParams.college_id = this.college;
				this.queryParams.degree = this.degree;
				queryMajorEnroll(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
					this.dataTips = res.data.totalData;
				});
			},

			exportMajorAcademy() {
				this.queryParams.top_code = this.topMajor;
				this.queryParams.parent_code = this.parentMajor;
				this.queryParams.code = this.major;
				this.queryParams.province_code = this.province;
				this.queryParams.city_code = this.city;
				this.queryParams.year = this.year;
				this.queryParams.degree = this.degree;
				exportMajorAcademy(this.queryParams).then(res => {
					let url = res.data.url;
					handleProtocal(url);
				});
			},

			loadCollegeList(name) {
				let params = {
					name: name
				}

				if (this.province) {
					params['province_code'] = this.province
				}

				if (this.city) {
					params['city_code'] = this.city
				}

				queryCollege(params).then(res => {
					this.collegeList = res.data.list;
				});
			},

			loadInnerCollegeList(name) {
				let params = {
					name: name
				}

				if (this.province) {
					params['province_code'] = this.province
				}

				if (this.city) {
					params['city_code'] = this.city
				}

				queryInnerCollege(params).then(res => {
					this.collegeList = res.data.list;
				});
			},


			queryAcademyMajor() {
				if (typeof this.college == 'undefined' || this.college == '') {
					this.$modal.msgError('请选择院校');
					return;
				}
				this.dataTips = '';
				analyzeClgMajor({
					college_id: this.college,
					year: this.industryYear
				}).then(res => {
					this.columnList = res.data.titleList;
					this.spanArr = getSpanMap(res.data.list, ['top_name'])
					this.dataList = res.data.list;
					this.dataTips = res.data.totalData;
				});
			},

			exportAcademyMajor() {
				if (typeof this.college == 'undefined' || this.college == '') {
					this.$modal.msgError('请选择院校');
					return;
				}

				if (this.leftTabList[this.activeLeftTab].type == 'academy_major' && (isEmpty(this.dataList) || this
						.dataList.length < 1)) {
					this.$modal.msgError('请先分析再操作');
					return;
				}

				exportClgMajor({
					college_id: this.college,
					year: this.industryYear
				}).then(res => {
					let url = res.data.url;
					handleProtocal(url)
				});
			},

			exportAcademyReport() {
				if (typeof this.college == 'undefined' || this.college == '') {
					this.$modal.msgError('请选择院校');
					return;
				}

				if (this.leftTabList[this.activeLeftTab].type == 'academy_major' && (isEmpty(this.dataList) || this
						.dataList.length < 1)) {
					this.$modal.msgError('请先分析再操作');
					return;
				}

				exportAcademyReport({
					college_id: this.college
				}).then(res => {
					let url = res.data.url;
					handleProtocal(url)
				});
			},

			clickAcademyRank() {
				if (typeof this.college == 'undefined' || this.college == '') {
					this.$modal.msgError('请选择院校');
					return;
				}

				if (this.leftTabList[this.activeLeftTab].type == 'academy_major' && (isEmpty(this.dataList) || this
						.dataList.length < 1)) {
					this.$modal.msgError('请先分析再操作');
					return;
				}

				queryAcademyRank({
					college_id: this.college
				}).then(res => {
					this.clgRankData = res.data;
					this.showClgRankDialog = true;
				});
			},

			closeClgRankDialog() {
				this.clgRankData = null;
				this.showClgRankDialog = false;
			},

			clickToReport() {
				// let path = "local://rank?level=高职&content_type=report&report_type=college_report&all_part=all"
				let path = this.clgRankData['reportUrl']
				handleProtocal(path)
				// this.closeClgRankDialog();
			},

			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				console.log(rowIndex)
				if (columnIndex === 0 || columnIndex === 1) {
					if (rowIndex % 2 === 0) {
						return {
							rowspan: 2,
							colspan: 1
						};
					} else {
						return {
							rowspan: 0,
							colspan: 0
						};
					}
				}
			},

			// 计算合并的行数 难搞😩
			caculateSpanColumns(column, row, rowIndex) {
				for (var i = rowIndex; i++; i < this.dataList.length) {
					if (i == rowIndex) {
						console.log(1)
					}
				}
			},


			queryIndustryRate() {
				let params = {
					province_code: this.province,
					city_code: this.city,
					college_id: this.college,
					year: this.industryYear,
					degree: this.degree
				};
				analyzeIndustryRate(params).then(res => {
					this.dataList = res.data.list;
				});
			},

			// loadSectorData() {
			// 	if (this.sectorTree.length > 0) {
			// 		return;
			// 	}

			// 	getSectorPage().then(res => {
			// 		this.sectorTree = res.data.industryTree;
			// 		this.degreeList = res.data.degreeList;
			// 		let params = this.$route.query
			// 		if (params && !isEmpty(params.activeLeftTab) && params.activeLeftTab == 4) {
			// 			this.sector = params.sector
			// 		}
			// 	});
			// },

			loadDegreeData() {
				if (this.degreeList.length > 0) {
					return;
				}

				getDegreeData().then(res => {
					this.degreeList = res.data.degreeList;
				});
			},


			queryMajorCollegeBySector() {
				let params = {
					province_code: this.province,
					city_code: this.city,
					sector: this.sector,
					childSector: this.childSector,
					degree: this.degree,
					year: this.industryYear
				};
				this.dataTips = '';
				analyzeMajorCollegeBySector(params).then(res => {
					this.dataList = res.data.list;
					this.dataTips = res.data.totalData;
				});
			},

			loadMajorIndustry(type) {

				if (type == 'query') {
					this.queryParams.page = 1;
				}
				this.queryParams.province_code = this.province;
				this.queryParams.city_code = this.city;
				this.queryParams.top_code = this.topMajor;
				this.queryParams.parent_code = this.parentMajor;
				this.queryParams.code = this.major;
				this.queryParams.degree = this.degree;
				this.queryParams.year = this.industryYear;
				this.dataTips = '';
				getMajorIndustry(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			exportMajorIndustry() {
				this.queryParams.province_code = this.province;
				this.queryParams.city_code = this.city;
				this.queryParams.top_code = this.topMajor;
				this.queryParams.parent_code = this.parentMajor;
				this.queryParams.code = this.major;
				this.queryParams.degree = this.degree;
				this.queryParams.year = this.industryYear;

				exportMajorIndustry(this.queryParams).then(res => {
					let url = res.data.url;
					handleProtocal(url);
				})
			},

			exportMajorCollegeBySector() {
				let params = {
					province_code: this.province,
					city_code: this.city,
					sector: this.sector,
					childSector: this.childSector,
					degree: this.degree,
					year: this.industryYear
				};
				exportMajorCollegeBySector(params).then(res => {
					let url = res.data.url;
					handleProtocal(url);
				});
			},

			getUserMajorGroup() {
				getUserMajorGroup(this.queryParams).then(res => {
					this.dataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			createUserGroup() {
				this.groupName = '';
				this.showGroupDialog = true;
			},

			confirmCreateGroup() {
				createMajorGroup({
					'name': this.groupName,
					'province': this.province
				}).then(res => {
					this.getUserMajorGroup();
					this.showGroupDialog = false;
				})
			},

			clickEditGroupMajor(id) {
				this.showGroupMajorDialog = true;
				this.curGroupId = id;
				this.groupDataList = [];
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.parentMajorList = []
				this.majorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = 0;
				this.loadGroupTopMajorList();
				this.queryGroupMajorData();
			},

			clickCloseGroupDialog() {
				this.showGroupMajorDialog = false;
				this.onGroupDialogClosed();
			},

			clickIndustry(path) {
				this.$router.push(path);
			},

			clickExportGroupReport(id) {

			},

			clickDelUserGroup(id) {
				this.$modal.confirm('确定要删除该条数据吗？').then(() => {
					deleteUserGroup({
						'id': id
					}).then(res => {
						this.getUserMajorGroup();
					})
				})
			},

			clickAddTab(index) {
				this.topMajor = '';
				this.parentMajor = '';
				this.major = '';
				this.parentMajorList = []
				this.majorList = [];
				this.groupQueryParams.page = 1;
				this.groupAddIndex = index;
				this.groupAddState = this.groupAddList[index]['value']
				this.queryGroupMajorData();
			},

			changeGroupTopMjor(value) {
				this.loadGroupParentMajorList('');
				this.majorList = []
				this.major = ''
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},

			changeGroupParentMajor(value) {
				this.groupQueryParams.page = 1;
				this.loadGroupMajorList('');
				this.queryGroupMajorData();
			},

			changeGroupMajor(value) {
				this.groupQueryParams.page = 1;
				this.queryGroupMajorData();
			},

			queryGroupMajorData() {
				this.groupQueryParams.group_id = this.curGroupId;
				this.groupQueryParams.top_code = this.topMajor;
				this.groupQueryParams.parent_code = this.parentMajor;
				this.groupQueryParams.code = this.major;
				this.groupQueryParams.isAdd = this.groupAddState;
				getGroupMajor(this.groupQueryParams).then(res => {
					this.groupDataList = res.data.list;
					this.total = res.data.pageData.totalCount;
				});
			},

			clickAddGroupMajor(code) {
				let params = {
					'group_id': this.curGroupId,
					'code': code
				}
				addGroupMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},

			clickRemoveGroupMajor(code) {
				let params = {
					'group_id': this.curGroupId,
					'code': code
				}
				removeGroupMajor(params).then(res => {
					this.queryGroupMajorData();
				});
			},

			onGroupDialogClosed() {
				this.getUserMajorGroup();
			},

			clickRoute(item) {
				console.log('item', item)
				let data = parse(item.url)

				if (data['head'] == 'replace') {
					let url = "/" + data['path'];
					if (data['data'] != null && data['data'].length != 0) {
						url += "?" + data['data'];
					}
					console.log('url', url)
					// this.$router.replace(url);
					this.$router.push(url);
				} else {
					handleRouteProtocal(data)
				}
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	@use "matrix.scss";
</style>